import { FC, ReactNode, useState } from 'react';
import { useCurrentUser } from '@hooks/users';
import { isUserStudent } from '@helpers';
import { ProfileSidebar, ProfileTab } from '../components/ProfileSidebar/ProfileSidebar';
import { PersonalInfoSection } from '../components/PersonalInfoSection/PersonalInfoSection';
import { BioSection } from '../components/BioSection/BioSection';
import { BillingInfoSection } from '../components/BillingInfoSection/BillingInfoSection';
import { EmailSettingsSection } from '../components/EmailSettingsSection/EmailSettingsSection';
import { PasswordSettingsSection } from '../components/PasswordSettingsSection/PasswordSettingsSection';
import { NotificationSettingsSection } from '../components/NotificationSettingsSection/NotificationSettingsSection';

const TAB_CONTENT: Record<ProfileTab, ReactNode> = {
  'personal-info': <PersonalInfoSection />,
  bio: <BioSection />,
  'billing-info': <BillingInfoSection />,
  'email-settings': <EmailSettingsSection />,
  'password-settings': <PasswordSettingsSection />,
  'notification-settings': <NotificationSettingsSection />,
};

export const ProfilePage: FC = () => {
  const [activeTab, setActiveTab] = useState<ProfileTab>('personal-info');
  const { data: user } = useCurrentUser();

  return (
    <div className="relative w-full h-full bg-[#FAFDFF] px-5 pb-5 flex flex-col gap-4 md:gap-6">
      <h1 className="[font-family:var(--font-arvo)] [font-size:var(--fs-h1)]! font-bold text-(--neutral-black-NB1000)! m-0!">
        Account Settings
      </h1>

      <div className="flex flex-col md:flex-row gap-4 md:gap-6">
        <ProfileSidebar
          activeTab={activeTab}
          onTabChange={setActiveTab}
          isStudent={!!user && isUserStudent(user)}
        />

        <div className="flex-1 bg-white rounded-lg border border-(--neutral-black-NB100) shadow-[0px_4px_32px_0px_#24242408] p-4 md:p-8">
          {TAB_CONTENT[activeTab]}
        </div>
      </div>
    </div>
  );
};
